import { render, staticRenderFns } from "./EModalCortarImagem.vue?vue&type=template&id=4b73b178"
import script from "./EModalCortarImagem.vue?vue&type=script&lang=js"
export * from "./EModalCortarImagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports